import { type Dispatch } from 'react';
import { match } from 'ts-pattern';

import { dispatchEvent } from '../../helper/EventUtils';
import { eventTypes } from '../../types';
import { type BuyboxReducerAction } from '../../types/buyboxReducerTypes';
import { type PurchaseType } from '../../types/enums/purchaseType';
import { BuyboxReducerActionType } from '../../types/enums/reducer/buyboxReducerAction';

const dispatchPurchaseType = (
    dispatch: Dispatch<BuyboxReducerAction>,
    value: PurchaseType,
): void => {
    dispatch({
        type: BuyboxReducerActionType.PurchaseType,
        value: { purchaseType: value },
    });
    dispatchEvent(eventTypes.BUYBOX_SELECTION_CHANGE, { purchaseType: value });
};

const dispatchResetErrors = (dispatch: Dispatch<BuyboxReducerAction>): void => {
    dispatch({ type: BuyboxReducerActionType.ResetErrors });
};

const handleErrorByCode = (dispatch: Dispatch<BuyboxReducerAction>, errorCode?: number): void => {
    match(errorCode)
        .with(102, () => {
            dispatch({ type: BuyboxReducerActionType.MixedShoppingCartError });
        })
        .with(1_101, () => {
            dispatch({ type: BuyboxReducerActionType.AddingMultipleItemsNotAllowedError });
        })
        .otherwise(() => {
            dispatch({ type: BuyboxReducerActionType.AddToCartError });
        });
};

export { dispatchPurchaseType, dispatchResetErrors, handleErrorByCode };
